<template>
  <div class="vuetable-pagination pagination-wrapper">

    <div class="pagination-button-wrapper">

      <vue-table-pagination ref="pagination"
                            :on-each-side="onEachSide"
                            @vuetable-pagination:change-page="onChangePage"
                            class="pagination"/>

      <!--<div class="pagination-title-wrapper">-->

        <!--<vue-table-pagination-info ref="paginationInfo"-->
                                   <!--class="pagination-info-wrapper"-->
                                   <!--:info-template="paginationTemplate.template"/>-->
      <!--</div>-->

    </div>

    <slot>
      아무것도 없습니다.
    </slot>

  </div>
</template>

<script>
import VueTablePagination from 'vuetable-2/src/components/VuetablePagination';

export default {
  name: 'BoardPagination',
  components: {
    VueTablePagination,
  },
  methods: {
    getPagination() {
      return this.$refs.pagination;
    },
    getPaginationInfo() {
      return this.$refs.paginationInfo;
    },
  },
  props: {
    onEachSide: {
      type: Number,
      default: 2,
    },

    paginationTemplate: {
      type: Object,
      isRequired: true,
    },

    onChangePage: {
      type: Function,
      isRequired: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-content: center;
  align-items: center;

  .pagination-button-wrapper {
    width: auto;
    height: 60px;

    display: flex;
    flex-direction: row;
    justify-content: space-around;

    .pagination-title-wrapper {
      position: relative;
      width: 100%;
      height: 60px;

      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;

      bottom: 10px;
    }

    .pagination {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-content: center;
      align-items: center;

      width: 100%;
      height: 40px;
    }
  }
}

@media screen and (max-width: 1024px) {
  .pagination-wrapper {
    flex-direction: column-reverse;
    justify-content: center;

    height: auto;

    .pagination-button-wrapper {
      margin-top: 12px;
      height: 40px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/table/components/pagination/BoardPagination.vue